import { render, staticRenderFns } from "./AddJob.vue?vue&type=template&id=10b3a90c&scoped=true"
import script from "./AddJob.vue?vue&type=script&lang=js"
export * from "./AddJob.vue?vue&type=script&lang=js"
import style0 from "./AddJob.vue?vue&type=style&index=0&id=10b3a90c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b3a90c",
  null
  
)

export default component.exports